// extracted by mini-css-extract-plugin
export var readonly = "_hr-1";
export var star = "_hr-0";